import { render, staticRenderFns } from "./CompTarifFull.vue?vue&type=template&id=1bcbd9bc"
import script from "./CompTarifFull.vue?vue&type=script&lang=js"
export * from "./CompTarifFull.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports